import React, { useState, useEffect } from "react";
import "katex/dist/katex.min.css";
import { H5PPlayerUI, H5PEditorUI } from "@lumieducation/h5p-react";

function H5PComponentTest(props) {
  const {
    mcData,
    isPractice,
    completed,
    isActive,
    onValueChange,
    onAttemptChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    handleSucAndFailFeedback,
    userId,
    initial,
    isResetClick,
    activityID,
    lessonID,
  } = props;

  const {
    ControlID,
    QuestionText,
    QuestionType,
    Description,
    Answers,
    Score,
    Background,
    AnswerColorFill,
    QuestionColorFill,
    AnswerFontSize,
    QuestionFontSize,
    Opacity,
    AnswerFillColor,
    QuestionFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    QuestionHeight,
    Priority,
    SequenceHint,
    ColQuestion,
    RowAnswer,
    BorderColor,
    X,
    Y,
    Height,
    Width,
    Url,
    LibraryName,
  } = mcData;
  const canvasAreaHeight = 100 - QuestionHeight;

  const [selectedAnswerArray, setSelectedAnswerArray] = useState([]);
  const [clearData, setClearData] = useState(false);

  useEffect(() => {
    window.addEventListener(
      "message",
      function receiveMessage(event) {
        // console.log(event);

        if (event.data.result === undefined) {
          return; // Only handle messages with result
        }
        console.log(" just result " + event.data);
        // console.log(" just scored " + event.data.result.score.raw);
      },
      false
    );
  }, []);

  function changeCssStyle() {
    let iframeId = `h5p-iframe-${Url}`;
    var iframe = document.getElementById(iframeId);
    var iframeDoc = iframe.contentWindow.document;
    var otherhead = iframeDoc.getElementsByTagName("head")[0];

    var css = document.createElement("link");
    css.type = "text/css";
    css.rel = "stylesheet";
    css.href = "https://h5pweb.knomadixapp.com/h5p/core/styles/h5p-test.css";

    otherhead.appendChild(css);
  }

  useEffect(() => {
    let emptyData = {
      preload: 1,
      invalidate: 1,
    };
    if (isResetClick) {
      setClearData(true);
      let urlValue = `https://h5pweb.knomadixapp.com/h5p/${Url}/${userId}${activityID}${lessonID}`;
      fetch(urlValue, {
        method: "delete",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(emptyData),
      }).then((response) => {
        console.log("responseData", response);
        setClearData(false);
      });
    }
  }, [isResetClick]);

  return (
    <div
      style={{
        top: isEmbeded ? Y : undefined,
        left: isEmbeded ? X : undefined,
        height: isEmbeded ? Height + "%" : "90vh",
        width: isEmbeded ? Width + "%" : "100%",
        position: isEmbeded ? "absolute" : "relative",
        justifyContent: "center",
        zIndex: 10,
      }}
    >
      <div
        // className="scrollBox"
        style={{
          width: "100%",
          height: "100%",
          justifyContent: "center",
          // borderRadius: isEmbeded ? 0 : "20px",
          backgroundColor: "#ffffff33",
          flexDirection: "column",
          alignSelf: "center",
          overflow:
            LibraryName === "Accordion" ||
            LibraryName === "InteractiveBook" ||
            LibraryName === "StructureStrip"
              ? "auto"
              : "hidden",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            // display: "flex",
          }}
        >
          <H5PPlayerUI
            // ref={props.id}
            contentId={clearData ? 1 : Url}
            onInitialized={(date) => {
              changeCssStyle();
              console.log("initializecall");
            }}
            onxAPIStatement={(statement, context, event) => {
              if (!initial) {
                onAttemptChange(1);
                if (statement && statement.result && statement.result.score) {
                  if (isEmbeded) {
                    onValueChange(ControlID, statement.result.score.raw);
                  } else {
                    onValueChange(
                      ControlID,
                      "",
                      statement.result.score.raw,
                      Score,
                      "",
                      false
                    );
                  }
                }
              }
            }}
            loadContentCallback={async (contentId) => {
              const h5pdata = fetch(
                `https://h5pweb.knomadixapp.com/h5p/${contentId}/play/${userId}${activityID}${lessonID}`
              )
                .then((response) => response.json())
                .then((data) => {
                  return data;
                })
                .then((data) => {
                  let dataValue = {};
                  if (
                    data.integration.contents["cid-" + contentId].jsonContent
                  ) {
                    dataValue = JSON.parse(
                      data.integration.contents["cid-" + contentId].jsonContent
                    );
                    if (dataValue.behaviour) {
                      if (dataValue.behaviour.enableRetry) {
                        dataValue.behaviour.enableRetry = false;
                      }
                      if (dataValue.behaviour.enableSolutionsButton) {
                        dataValue.behaviour.enableSolutionsButton = false;
                      }
                      // if (dataValue.behaviour.enableCheckButton) {
                      //   dataValue.behaviour.enableCheckButton = false;
                      // }

                      // if (
                      //   dataValue.behaviour.autoCheck &&
                      //   dataValue.behaviour.autoCheck === false
                      // ) {
                      //   dataValue.behaviour.autoCheck = true;
                      // }
                      if (
                        dataValue.behaviour.instantFeedback &&
                        dataValue.behaviour.instantFeedback === false
                      ) {
                        dataValue.behaviour.instantFeedback = true;
                      }
                      if (
                        dataValue.behaviour.autoContinue &&
                        dataValue.behaviour.autoContinue === true
                      ) {
                        dataValue.behaviour.autoContinue = false;
                      }
                      if (
                        dataValue.behaviour.enableShowSolution &&
                        dataValue.behaviour.enableShowSolution === true
                      ) {
                        dataValue.behaviour.enableShowSolution = false;
                      }
                      if (
                        dataValue.behaviour.hasOwnProperty("enableCheckButton")
                      ) {
                        dataValue.behaviour.enableCheckButton = true;
                      }
                      if (dataValue.behaviour.hasOwnProperty("autoCheck")) {
                        dataValue.behaviour.autoCheck = false;
                      }
                    }

                    if (dataValue.endGame) {
                      if (dataValue.endGame.showResultPage) {
                        dataValue.endGame.showResultPage = false;
                      }
                      if (dataValue.endGame.showSolutionButton) {
                        dataValue.endGame.showSolutionButton = false;
                      }
                      if (dataValue.endGame.showRetryButton) {
                        dataValue.endGame.showRetryButton = false;
                      }
                    }
                    data.integration.contents["cid-" + contentId].jsonContent =
                      JSON.stringify(dataValue);
                  }
                  data.user.id = userId;
                  data.integration.ajax.setFinished = `https://h5pweb.knomadixapp.com/h5p/finishedData/${userId}${activityID}${lessonID}`;
                  data.integration.ajax.contentUserData = `https://h5pweb.knomadixapp.com/h5p/contentUserData/${contentId}/:dataType/:subContentId/${userId}${activityID}${lessonID}?=`;
                  console.log("h5pDataConsole", data);
                  return data;
                });
              return h5pdata;
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default H5PComponentTest;
